<template>
  <div class="pk-home-wrapper">
    <div class="pk-home-page">
      <div class="pk-flex">
        <template v-for="(it,i) in items">
          <div class="pk-flex__1 pk-flex--column pk-home-boxitem" :key="i"
           :class="'pk-home-box-'+i">
            <img
             class="pk-flex__00auto"
             :src="'static/' + it.img + '.jpg'"
             style="max-width:100%;">
          </div>
        </template>
      </div>
      <div class="pk-flex">
        <template v-for="(it,i) in items">
          <div class="pk-flex__1 pk-flex--column pk-home-boxitem" :key="i"
           :class="'pk-home-box-'+i">
            <div class="text-center __box-title">{{it.title}}</div>
          </div>
        </template>
      </div>
      <div class="pk-flex">
        <template v-for="(it,i) in items">
          <div class="pk-flex__1 pk-flex--column pk-home-boxitem" :key="i"
           :class="'pk-home-box-'+i">
            <div class="pk-flex__1 __box-text"
             v-html="getText(it.title)"></div>
          </div>
        </template>
      </div>

      <div class="pk-flex">
        <template v-for="(it,i) in items">
          <div class="pk-flex__1 pk-flex--column pk-home-boxitem" :key="i"
           :class="'pk-home-box-'+i">
            <div class="text-center __box-link">
              <router-link v-if="it.link_to"
               class="pk-flex__00auto"
               :to="it.link_to"><span>{{it.link_title}}</span></router-link>
              <a v-if="it.a_title"
               target="_blank"
               :href="it.a_href"
               class="pk-flex__00auto"><span>{{it.a_title}}</span></a>
            </div>
          </div>
        </template>
      </div>

    </div>
  </div>

</template>

<script>
import Vue from 'vue';
export default Vue.extend({
  data() {
    return {};
  },
  created() {
    this.$store.dispatch('firstRun');
  },
  mounted() {
    if (this.$matomo) {
      this.$matomo.trackPageView('Home');
    }
  },
  computed: {
    frontText() {
      return this.$store.state.frontText;
    },
    items() {
      return [{
          style: '', // border:2px solid rgb(3, 106, 177)
          img: 'intro-archive',
          title: 'eLaterna Archive',
          link_to: 'ea',
          link_title: 'enter eLaterna Archive'
        },
        {
          style: '', // 'border:2px solid rgb(5, 113, 125)',
          img: 'intro-companion',
          title: 'eLaterna Companion',
          // a_href: 'http://tcdh01.uni-trier.de:9191',
          a_href: ' http://elaterna-companion.uni-trier.de',
          a_title: 'enter eLaterna Companion'
        }, 
        {
          style: "", //'border:2px solid rgb(5, 113, 125)',
          img: "timeline",
          title: "Timeline",
          link_to: "timeline",
          link_title: "enter eLaterna Timeline",
        },
        {
          style: '', // 'border:2px solid rgb(182, 133, 38)',
          img: 'intro-lucerna',
          title: 'Lucerna',
          a_href: 'http://lucerna.exeter.ac.uk/',
          a_title: 'go to Lucerna Website'
        }
      ];
    }
  },
  methods: {
    getImg(name) {
      return this.$getIcon(name);
    },
    getText(key) {
      const obj = this.frontText.find((a) => a.key === key);
      return obj ? obj.text : '';
    }
  }

});
</script>

<style lang="scss" scoped>
@import '../assets/scss/variable.scss';
@import '../assets/scss/layout.scss';
@import '../assets/scss/color.scss';
@import '../assets/scss/size.scss';

.pk-home-wrapper {
  @extend .pk-flex__h-center;
  .pk-home-page {
    min-width: $homeMinWidth;
    max-width: $homeMaxWidth;
    padding: 30px;
    overflow: auto;
    .pk-home-boxitem {
      margin: 0px 20px;
      .__box-title {
        padding: 5px;
      }
      .__box-text {
        font-size: 12px;
        padding: 10px 10px 10px 10px;
      }
      .__box-link {
        padding: 10px 10px 15px 10px;
      }
    }
  }
}

$col1-main-color:rgb(0, 94, 170);
$col1-bg-color:rgb(239, 242, 247);
.pk-home-box-0 {
  .__box-title {
    background-color: $col1-main-color;
    color: #fff;
  }
  .__box-text {
    background-color: $col1-bg-color;
    border: 2px solid $col1-main-color;
    border-bottom: 0;
    border-top: 0
  }
  .__box-link {
    background-color: $col1-bg-color;
    border: 2px solid $col1-main-color;
    border-top: 0;
    span {
      background-color: rgb(200, 209, 231);
      border-radius: 5px;
      padding: 5px 20px;
      color: $col1-main-color;
    }
  }
}

$col2-main-color:rgb(5, 113, 125);
$col2-bg-color:rgb(224, 234, 234);
.pk-home-box-1 {
  .__box-title {
    background-color: $col2-main-color;
    color: #fff;
  }
  .__box-text {
    background-color: $col2-bg-color;
    border: 2px solid $col2-main-color;
    border-bottom: 0;
    border-top: 0;
  }
  .__box-link {
    background-color: $col2-bg-color;
    border: 2px solid $col2-main-color;
    border-top: 0;
    span {
      background-color: rgb(185, 215, 217);
      border-radius: 5px;
      padding: 5px 20px;
      color: $col2-main-color;
    }
  }
}

$col2-main-color: #492a72;
$col2-bg-color: #efedf5;

.pk-home-box-2 {
  .__box-title {
    background-color: $col2-main-color;
    color: #fff;
  }
  .__box-text {
    background-color: $col2-bg-color;
    border: 2px solid $col2-main-color;
    border-bottom: 0;
    border-top: 0;
  }
  .__box-link {
    background-color: $col2-bg-color;
    border: 2px solid $col2-main-color;
    border-top: 0;
  }
  span {
    background-color: #cdc5da;
    border-radius: 5px;
    padding: 5px 20px;
    color: $col2-main-color;
  }
}

$col3-main-color:rgb(182, 133, 38);
$col3-bg-color:#f4e9d3;
.pk-home-box-3 {
  .__box-title {
    background-color: $col3-main-color;
    color: #fff;
  }
  .__box-text {
    background-color: $col3-bg-color;
    border: 2px solid $col3-main-color;
    border-bottom: 0;
    border-top: 0;
  }
  .__box-link {
    background-color: $col3-bg-color;
    border: 2px solid $col3-main-color;
    border-top: 0;
  }
  span {
    background-color: #e5cf9a;
    border-radius: 5px;
    padding: 5px 20px;
    color: $col3-main-color;
  }
}
</style>